var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('pt-page-title',{attrs:{"title":"批量订单"}}),_c('router-link',{attrs:{"to":"/order-new"}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("新建批量订单")])],1),_c('pt-lot-list-filter-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }